import { Form } from 'react-bootstrap';
import ModalCustom from '../../UI/modal';
import Button from '../../UI/button';
import { useEffect, useState } from 'react';
import { InviteCollaborator } from '../../../services/trip-invitation.service';
import { SortByTitleDesc } from '../../../Models/sortby.model';
import tripsService from '../../../services/trips/trips.service';

export interface AddCollaboratorFormModel {
  inviteeEmail: string;
  tripId: string;
  invitationRole: 'owner' | 'contributor' | 'follower';
}

type Props = {
  show: boolean;
  handleClose: (addSuccess: boolean) => void;
  tripId: string;
};

const CollaboratorAddModal = ({ show, handleClose, tripId }: Props) => {
  const [formData, setFormData] = useState<AddCollaboratorFormModel>({
    inviteeEmail: '',
    tripId: tripId,
    invitationRole: 'contributor'
  });
  const [fetchedTrips, setFetchedTrips] = useState<any[]>([]);

  // Update tripId in formData when prop changes
  useEffect(() => {
    setFormData((prev) => ({ ...prev, tripId: tripId }));
  }, [tripId]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();

    // Validate tripId exists
    if (!formData.tripId) {
      alert('Trip ID is required. Please ensure a trip is selected.');
      return;
    }

    try {
      const response = await InviteCollaborator(formData);
      console.log(response);

      if (response && response.status === 'success') {
        alert('Collaborator was successfully invited to your trip');
        handleClose(true);
      } else {
        alert('Failed to send invitation. Please try again.');
      }
    } catch (error) {
      console.error('Error inviting collaborator:', error);
      alert('An error occurred while sending the invitation.');
    }
  };

  useEffect(() => {
    async function fetchData() {
      // You can await here
      const tmp = await tripsService.getTrips(SortByTitleDesc);
      setFetchedTrips(tmp);
      // ...
    }
    fetchData();
  }, []);

  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title='Add Collaborator'
      paddingBody='0 32px 32px 32px'
      paddingHeader='32px 32px 24px 32px'
    >
      <div className='collaborator-add-modal-body'>
        <Form onSubmit={handleSubmit}>
          <Form.Group style={{ marginBottom: '24px' }}>
            <Form.Label>Invitee Email</Form.Label>
            <Form.Control
              required
              type='email'
              placeholder='Enter here'
              onChange={(e) =>
                setFormData({ ...formData, inviteeEmail: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: '24px' }}>
            <Form.Label>Invitation Role</Form.Label>
            <Form.Select
              required
              aria-placeholder='Select'
              onChange={(e) =>
                setFormData({
                  ...formData,
                  invitationRole: e.target.value as
                    | 'owner'
                    | 'contributor'
                    | 'follower'
                })
              }
            >
              <option
                disabled
                value=''
                selected={true}
              >
                Select
              </option>
              <option value='contributor'>Contributor</option>
              <option value='follower'>Follower</option>
              <option value='owner'>Owner</option>
            </Form.Select>
          </Form.Group>
          {tripId === '' && (
            <Form.Group style={{ marginBottom: '24px' }}>
              <Form.Label>Trip</Form.Label>
              <Form.Select
                id='move-to-trip'
                style={{ marginBottom: '24px' }}
                onChange={(e) =>
                  setFormData({ ...formData, tripId: e.target.value })
                }
              >
                <option
                  disabled
                  value='-1'
                  selected={true}
                >
                  {' '}
                  select{' '}
                </option>
                {Array.isArray(fetchedTrips) &&
                  fetchedTrips.map((folder, index) => (
                    <option
                      key={index}
                      value={folder.id}
                    >
                      {folder.title}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
          )}
          <Button
            variant='primary'
            width={167}
            className='mx-auto'
            type='submit'
          >
            Add Collaborator
          </Button>
        </Form>
      </div>
    </ModalCustom>
  );
};
export default CollaboratorAddModal;
